import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Hostage } from './types';
import { useTranslation } from 'react-i18next';
import { NavigateBefore } from '@mui/icons-material';
import { IconButton, Box, Typography } from '@mui/material';
import { t } from 'i18next';
import plus from '../icons/plus-circle.svg';
import '../style/ImageGrid.css';
import { styled } from '@mui/system';

type Props = {
  hostages: Hostage[];
  onItemClick: (id: string) => void;
  onMoreHostagesClick?: () => void;
  horizontalScroll?: boolean;
};

export default function TitlebarImageList({
  hostages,
  onItemClick,
  onMoreHostagesClick,
  horizontalScroll = false,
}: Props) {
  const { i18n } = useTranslation();

  const GradientOverlay = styled('div')(({ theme }) => ({
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '60px', // Adjust this value based on your need
    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0))',
  }));

  const getHostageTitle = (hostage: Hostage) => {
    const hostageName = hostage[i18n.language as 'en' | 'he'].name_with_title;
    return horizontalScroll && hostage.age ? `${hostageName}, ${hostage.age}` : hostageName;
  };

  return (
    <ImageList
      sx={{
        width: '100%',
        overflow: 'hidden',
        display: horizontalScroll ? 'flex' : 'grid',
        gap: '8px !important',
        fontFamily: 'noto sans hebrew',
        ...(horizontalScroll
          ? { padding: '0', overflowX: 'auto' } // Horizontal scroll styling
          : {
              gridTemplateColumns: 'repeat(2, 1fr)', // Grid layout
              gridAutoRows: '1fr',
            }),
      }}
    >
      {hostages.map((item) => (
        <ImageListItem
          key={item.id}
          onClick={() => onItemClick(item.id)}
          sx={{
            aspectRatio: '0.873',
            borderRadius: '8px',
            overflow: 'hidden',
            flex: horizontalScroll ? '0 0 auto' : undefined,
            width: horizontalScroll ? '109px !important' : undefined,
            height: horizontalScroll ? '190px !important' : undefined,
          }}
        >
          <img
            srcSet={item.photo}
            src={item.photo}
            alt={item[i18n.language as 'en' | 'he'].name_with_title}
            loading='lazy'
          />
          {item.first_name === "משפחת ביבס" && <span className='heart-emoji'
          style={{
            position: 'absolute',
            top: '2px', // Adjust to control spacing from the top
            left: '2px', // Adjust to control spacing from the left
            fontSize: '18px', // Adjust emoji size
            zIndex: 2, // Ensure it appears above the image
          }}>❤️🖤🖤🖤</span>}
          {item.isBack && item.is_alive !== false && item.first_name !== "משפחת ביבס" && <span className='heart-emoji'
          style={{
            position: 'absolute',
            top: '2px', // Adjust to control spacing from the top
            left: '2px', // Adjust to control spacing from the left
            fontSize: '18px', // Adjust emoji size
            zIndex: 2, // Ensure it appears above the image
          }}>❤️</span>}
          {item.isBack && item.is_alive === false && <span className='heart-emoji'
          style={{
            position: 'absolute',
            top: '2px', // Adjust to control spacing from the top
            left: '2px', // Adjust to control spacing from the left
            fontSize: '18px', // Adjust emoji size
            zIndex: 2, // Ensure it appears above the image
          }}>🖤</span>}
          <GradientOverlay />
          <ImageListItemBar
            sx={{
              background: 'none',
              '.MuiImageListItemBar-titleWrap': {
                padding: '0 !important',
              },
              '.MuiImageListItemBar-title': {
                fontSize: '16px !important',
                padding: '12px 5px !important',
                textAlign: horizontalScroll ? 'center !important' : 'start',
              },
            }}
            title={getHostageTitle(item)}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}
